import { useState } from 'react';
import { Link } from 'react-router-dom';
import { http } from '@/lib/api';
import { toast } from 'sonner';
import { pickWelcomeBackground } from '@/lib/branding';

export default function ForgotPassword() {
  const [email, setEmail] = useState(''); const [sent, setSent] = useState(false); const [loading, setLoading] = useState(false);
  const [bg] = useState(pickWelcomeBackground);
  const submit = async (e) => { e.preventDefault(); setLoading(true);
    try { await http.post('/auth/forgot-password', { email }); setSent(true); }
    catch { toast.error('Something went wrong'); }
    setLoading(false);
  };
  return (
    <div className="min-h-screen bg-navy bg-cover bg-center relative flex items-center justify-center p-6" style={{ backgroundImage: `url(${bg})` }}>
      <div className="absolute inset-0 bg-gradient-to-b from-navy/60 via-navy/45 to-navy/85" />
      <div className="relative z-10 w-full max-w-md bg-white rounded-3xl p-8 card-soft" data-testid="forgot-page">
        <Link to="/login" className="text-sm text-navy/60">← Back</Link>
        <h1 className="font-heading text-3xl mt-4 mb-2">Reset your password</h1>
        {sent ? (
          <p className="text-navy/70 mt-4">If that email exists, we&apos;ve sent a reset link. Check your inbox — the link expires in 1 hour.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4 mt-4">
            <input data-testid="forgot-email" type="email" required value={email} onChange={e=>setEmail(e.target.value)}
              placeholder="you@email.com"
              className="w-full bg-[#F9F8F6] border border-navy/10 rounded-2xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-gold" />
            <button data-testid="forgot-submit" disabled={loading}
              className="w-full bg-navy text-white rounded-full py-4 font-medium hover:bg-navy-soft disabled:opacity-50">
              {loading ? 'Sending…' : 'Send reset link'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
